/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { Paper, Button } from "@material-ui/core";
import { makeStyles, fade } from "@material-ui/core/styles";

import CancelIcon from "@material-ui/icons/Cancel";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Draggable } from "react-beautiful-dnd";
import StoredAPI from "../../utils/StoredAPI";
// Importar la fuente
import AlbertSansSemiBold from "../../assets/fonts/AlbertSans-Bold.woff";
import AlbertSansRegular from "../../assets/fonts/AlbertSans-Regular.woff";
import Checkbox from "@material-ui/core/Checkbox";
import useCheckBook from "../../hooks/useCheckBook";
import { message } from "antd/es";
import limitStringLength from "../../utils/limitStringLength";
import useLift from "../../hooks/useLift";
import usePiloto from "../../hooks/usePiloto";
import CountrySelect from "./CountrySelect";
import PhoneInput from "react-phone-number-input/input";
import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumber,
} from "react-phone-number-input";

const CA_FIRST = ["GT", "SV", "HN", "NI", "CR", "PA", "BZ", "MX"];
const PHONE_COUNTRIES = [
  ...CA_FIRST,
  ...getCountries().filter((c) => !CA_FIRST.includes(c)),
];

const getPhoneCountry = (area) => {
  if (!area) return "GT";
  if (/^[A-Z]{2}$/.test(area)) return area;
  const dial = area.replace(/^\+/, "");
  return getCountries().find((c) => getCountryCallingCode(c) === dial) || "GT";
};

const buildPhoneE164 = (area, celular) => {
  if (!celular) return undefined;
  if (celular.startsWith("+")) return celular;
  const iso = getPhoneCountry(area);
  try {
    const digits = celular.replace(/\D/g, "");
    if (!digits) return undefined;
    return `+${getCountryCallingCode(iso)}${digits}`;
  } catch {
    return undefined;
  }
};

const useStyles = makeStyles((theme) => ({
  "@font-face": [
    {
      fontFamily: "AlbertSansSemiBold",
      src: `url(${AlbertSansSemiBold}) format('opentype')`,
    },
    {
      fontFamily: "AlbertSansRegular",
      src: `url(${AlbertSansRegular}) format('opentype')`,
    },
  ],
  customFont: {
    fontFamily: "AlbertSansSemiBold, sans-serif",
    fontWeight: "bold",
    fontSize: "17px",
    color: "#000",
    whiteSpace: "pre",
  },
  customFontRegular: {
    color: "#fff",
    display: "block",
    fontFamily: "AlbertSansRegular, sans-serif",
  },
  titleChequero: {
    color: "#fff",
    display: "block",
    fontFamily: "AlbertSansRegular, sans-serif",
    fontSize: "16px",
    marginBottom: "10px",
  },
  subTitleChequero: {
    color: "#fff",
    display: "block",
    fontFamily: "AlbertSansRegular, sans-serif",
    fontSize: "14px",
    textAlign: "right",
  },
  card: {
    maxWidth: "100%",
    borderColor: "#fff",
    backgroundColor: "#0f0f18",
    borderWidth: 1,
    marginVertical: 5,
    padding: 10,
    borderRadius: 5,
    marginBottom: 10,
  },
  popupScreen: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: "0",
    right: "0",
    left: "0",
    backgroundColor: fade("#121219", 0.86),
    cursor: "not-allowed",
    zIndex: 1000,
  },
  popup: {
    width: "600px",
    height: "auto",
    borderRadius: "10px",
    backgroundColor: "white",
    padding: theme.spacing(4),
    position: "relative",
    cursor: "auto",
    zIndex: "99999",
    backgroundColor: "#21212d",
  },
  cancel: {
    cursor: "pointer",
    position: "absolute",
    right: "0",
    top: "0",
    color: "#fff",
    margin: theme.spacing(4),
  },
  input: {
    maxWidth: "600px",
    height: "fit-content",
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    "&:focus": {
      backgroundColor: "#ddd",
    },
    fontSize: "14px",
  },
  editableTitle: {
    maxWidth: "600px",
    flexGrow: "1",
    color: "grey",
    marginTop: theme.spacing(4),
    fontSize: "14px",
  },
  small: {
    fontSize: "12px",
    color: "grey",
    marginTop: theme.spacing(1),
    color: "#fff",
  },
  dragItemStyle: {
    borderColor: "#0f0f18",
    backgroundColor: "#0f0f18",
    borderWidth: 1,
    borderWidth: 10,
    marginVertical: 5,
    padding: 5,
    borderRadius: 5,
    position: "relative",
  },
  dragItemStyleEntrada: {
    border: "2px solid #2ECC71"
  },
  dragItemStyleSalida: {
    border: "2px solid #E67E22"
  },
  dragItemStyleSalida3B: {
    border: "2px solid #4FC3F7"
  },
  horizontalContainer: {
    display: "flex", // Add this line to set the container as a flex container
    flexDirection: "row",
    flex: 1,
  },
  leftContainer: {
    flexGrow: 1,
    flex: 1,
  },
  dragItemTextStyle: {
    color: "#fff",
    fontSize: 15,
    fontFamily: "AlbertSansSemiBold",
    // overflow: "hidden", // Ocultar el texto que desborda
    textOverflow: "ellipsis", // Reemplazar el texto restante con puntos suspensivos
    whiteSpace: "nowrap", // Forzar el texto a una sola línea
    display: "block",
  },
  dragItemCodeStyle: {
    color: "#A6A8AA",
    fontSize: 15,
    fontFamily: "AlbertSansSemiBold",
    // overflow: "hidden", // Ocultar el texto que desborda
    textOverflow: "ellipsis", // Reemplazar el texto restante con puntos suspensivos
    whiteSpace: "nowrap", // Forzar el texto a una sola línea
    display: "block",
    paddingBottom: 5,
  },
  viewProcentajeStyle: {
    borderRadius: 30,
    width: 50,
    height: 30,
    paddingTop: 4,
    backgroundColor: "#69dfa5",
    display: "block",
  },
  dragItemProcentajeStyle: {
    color: "#000",
    textAlign: "center",
    fontSize: 15,
    width: 50,
    height: 30,
    fontFamily: "AlbertSansSemiBold",
    display: "block",
  },
  contChequeros: {
    border: "1px solid #3a3a44",
    borderRadius: "5px",
    padding: "8px 0px",
    marginTop: "30px",
  },
  contNombre: {
    color: "#A6A8A8",
    fontFamily: "AlbertSansRegular",
    fontSize: "13px",
    padding: "6px 16px",
    borderBottom: "1px solid #3a3a44",
  },
  conChequero: {
    color: "#A6A8A8",
    alignItems: "center",
    fontFamily: "AlbertSansSemiBold",
    fontSize: "13px",
    padding: "3px 16px",
    borderBottom: "1px solid #3a3a44",
    display: "flex",
    justifyContent: "space-between",
  },
  lastConChequero: {
    borderBottom: "none",
  },
  btnConfirm: {
    backgroundColor: "#00bb7d",
    color: "#fff",
    fontFamily: "AlbertSansSemiBold",
    "&:hover": {
      backgroundColor: "#00bb7d",
    },
    cursor: "pointer",
    marginTop: "40px",
    marginLeft: "auto",
    padding: "5px 15px",
  },
  container: {
    display: "flex",
    justifyContent: "flex-end",
  },
  cardDisabled: {
    // pointerEvents: "none",
    opacity: 0.5,
    filter: "grayscale(50%)",
    cursor: "not-allowed",
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "30px",
  },
  menuButton: {
    backgroundColor: "#21212d",
    border: "1px solid #3a3a44",
    color: "#fff",
    fontFamily: "AlbertSansSemiBold",
    fontSize: "16px",
    textTransform: "none",
    padding: "16px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#2c2c3a",
    },
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  backCircle: {
    backgroundColor: "#69dfa5",
    color: "#000",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#5bd198",
    },
  },
  pilotosList: {
    marginTop: "20px",
    maxHeight: "60vh",
    overflowY: "auto",
  },
  pilotoCard: {
    border: "1px solid #3a3a44",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "16px",
    backgroundColor: "#1a1a24",
  },
  pilotoFieldRow: {
    display: "flex",
    gap: "10px",
  },
  pilotoField: {
    marginBottom: "12px",
    flex: 1,
  },
  pilotoLabel: {
    color: "#A6A8AA",
    fontFamily: "AlbertSansRegular",
    fontSize: "12px",
    display: "block",
    marginBottom: "4px",
  },
  pilotoInput: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#21212d",
    border: "1px solid #3a3a44",
    borderRadius: "5px",
    color: "#fff",
    fontFamily: "AlbertSansRegular",
    fontSize: "15px",
    padding: "10px",
    outline: "none",
    "&:focus": {
      borderColor: "#69dfa5",
    },
  },
  phoneInputWrapper: {
    display: "flex",
    alignItems: "stretch",
    gap: "6px",
  },
  pilotoSaveBtn: {
    backgroundColor: "#00bb7d",
    color: "#fff",
    fontFamily: "AlbertSansSemiBold",
    textTransform: "none",
    width: "100%",
    marginTop: "8px",
    padding: "8px 15px",
    "&:hover": {
      backgroundColor: "#00bb7d",
    },
    "&.Mui-disabled": {
      backgroundColor: "#3a3a44",
      color: "#A6A8AA",
    },
  },
  emptyState: {
    color: "#A6A8AA",
    fontFamily: "AlbertSansRegular",
    fontSize: "14px",
    textAlign: "center",
    padding: "30px 0",
  },
}));

const Card = ({
  card,
  cardIndex,
  listIndex,
  type,
  checkBooks,
  forkliftDrivers,
  getContainerPosition,
}) => {
  const { assignCheckBook } = useCheckBook();
  const { assignForklift } = useLift();
  const { editPiloto } = usePiloto();
  const { updateCardContent, finalizarCard, cambiarStatus, reActivarCard } =
    useContext(StoredAPI);
  const classes = useStyles();
  const { chequeros_asignados, montacargas_asignados } = card.extendedProps;
  const pilotos_asignados = card.extendedProps?.pilotos_asignados || [];
  const [popup, setPopup] = useState(false);
  const [popupView, setPopupView] = useState("menu");
  const [pilotosForm, setPilotosForm] = useState([]);
  const [savingId, setSavingId] = useState(null);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(card.content);
  const values = Object.values(card);
  const valueStrings = values.map((value) => String(value)); // Convertir los valores a cadenas
  const [checkedState, setCheckedState] = React.useState({});
  const urlParams = new URLSearchParams(window.location.search);
  const tipo = urlParams.get("tipo");
  const listUsers = tipo === "salida" ? forkliftDrivers : checkBooks;
  // const cardDisabled =
  //   card?.extendedProps?.ingreso_salida?.toLowerCase() !== tipo?.toLowerCase();

  const handleChange = (event, id) => {
    setCheckedState({ ...checkedState, [id]: event.target.checked });
  };

  useEffect(() => {
    if (tipo === "salida") {
      if (montacargas_asignados.length > 0) {
        let newCheckedState = {};
        for (const checkBook of montacargas_asignados) {
          newCheckedState[checkBook.usu_id] = checkBook.usu_id;
        }

        setCheckedState(newCheckedState);
      }
    } else {
      if (chequeros_asignados.length > 0) {
        let newCheckedState = {};
        for (const checkBook of chequeros_asignados) {
          newCheckedState[checkBook.usu_id] = checkBook.usu_id;
        }

        setCheckedState(newCheckedState);
      }
    }
  }, [popup]);

  const getCardTitle = () => {
    if (card?.titulo?.length > 17) {
      return card?.titulo?.slice(0, 17) + "...";
    }
    return card?.titulo;
  };

  const assignCheckBookHandler = async () => {
    const checkBooksIds = [];
    for (const key in checkedState) {
      if (checkedState[key]) {
        checkBooksIds.push(key);
      }
    }

    if (checkBooksIds.length === 0) {
      return message.error('Selecciona los o el montacarga a asignar')
    }

    const data = {
      usu_id: checkBooksIds.join(","),
    };



    if (tipo === "salida") {
      data.sal_id = card.extendedProps.sal_id;
    } else {
      data.codigo_pilotocarta = card.extendedProps.codigo_pilotocarta;
    }

    const functionToExecute =
      tipo === "salida" ? assignForklift : assignCheckBook;
    const response = await functionToExecute(data);

    if (response) {
      setPopup(false);
      getContainerPosition();
    }
  };

  const initPilotosForm = () => {
    setPilotosForm(
      pilotos_asignados.map((piloto) => ({
        id_piloto: piloto.id_piloto,
        nombre_piloto: piloto.nombre_piloto || "",
        documento: piloto.documento || "",
        celular: piloto.celular || "",
        area: piloto.area || "",
      }))
    );
  };

  const handlePilotoFieldChange = (id_piloto, field, value) => {
    setPilotosForm((prev) =>
      prev.map((piloto) =>
        piloto.id_piloto === id_piloto ? { ...piloto, [field]: value } : piloto
      )
    );
  };

  const handlePhoneChange = (id_piloto, e164) => {
    setPilotosForm((prev) =>
      prev.map((p) => {
        if (p.id_piloto !== id_piloto) return p;
        if (!e164) return { ...p, celular: "" };
        try {
          const parsed = parsePhoneNumber(e164);
          return { ...p, celular: parsed.nationalNumber };
        } catch (err) {
          if (err.message === "TOO_LONG") return p;
          // Partial number (TOO_SHORT) — strip calling code prefix and store
          const iso = getPhoneCountry(p.area);
          try {
            const prefix = `+${getCountryCallingCode(iso)}`;
            if (e164.startsWith(prefix)) {
              return { ...p, celular: e164.slice(prefix.length) };
            }
          } catch {}
          return { ...p, celular: e164 };
        }
      })
    );
  };

  const handleSavePiloto = async (piloto) => {
    setSavingId(piloto.id_piloto);
    const ok = await editPiloto({
      id_piloto: piloto.id_piloto,
      documento: piloto.documento,
      nombre_piloto: piloto.nombre_piloto,
      celular: piloto.celular,
      area: piloto.area,
    });
    setSavingId(null);
    if (ok) {
      getContainerPosition();
    }
  };

  const openPopup = () => {
    if (card?.extendedProps?.ingreso_salida === "Ingreso") {
      initPilotosForm();
      setPopupView("pilotos");
    } else {
      setPopupView("menu");
    }
    setPopup(true);
  };

  const valueElements = (
    <React.Fragment>
      <div
        className={`${classes.dragItemStyle}`}
      >
        <div className={classes.horizontalContainer}>
          <div className={classes.leftContainer}>
            <div>
              <span className={classes.dragItemTextStyle}>
                {getCardTitle()}
              </span>
            </div>

            <span className={classes.dragItemCodeStyle}>
              {limitStringLength(card.codigo, 17)}
            </span>

                {card.extendedProps?.sal_codigo && (
              <p style={{ marginBottom: 0, fontSize: 12 }} className={classes.dragItemCodeStyle}><span style={{ fontSize: 16}}>{card.extendedProps?.sal_codigo}</span></p>
              )}

            {card.extendedProps?.ubicacion && (
              <p style={{ marginBottom: 0, fontSize: 12 }} className={classes.dragItemCodeStyle}>Bodega: <span style={{color: '#FFF', fontSize: 16}}>{card.extendedProps?.ubicacion}</span></p>
              )}
        
            <span
              style={{
                fontSize: 10,
                position: "absolute",
                right: 0,
                bottom: -16,
              }}
              className={classes.dragItemCodeStyle}
            >
              {card.extendedProps.ingreso_salida}
            </span>
          </div>
          <div className={classes.viewProcentajeStyle}>
            <span className={classes.dragItemProcentajeStyle}>
              {card.porcentaje}%
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  const handleOnDone = () => {
    if (content.length <= 1060) {
      updateCardContent(content, listIndex, cardIndex);
      setOpen(!open);
    } else {
      alert(
        "Character limit exceeded. Try to add note within 1060 characters."
      );
    }
  };

  const handleArchivar = () => {
    finalizarCard(listIndex, cardIndex);
    setPopup(false);
  };

  const handleReActivar = () => {
    reActivarCard(listIndex, cardIndex);
    setPopup(false);
  };

  const handleEntrar = () => {
    cambiarStatus(listIndex, cardIndex, "entrar");
    setPopup(false);
  };

  const handleSalir = () => {
    cambiarStatus(listIndex, cardIndex, "salir");
    setPopup(false);
  };
  return (
    <div>
      {popup && (
        <div className={classes.popupScreen} onClick={() => setPopup(false)}>
          <div className={classes.popup} onClick={(e) => e.stopPropagation()}>
            <CancelIcon
              className={classes.cancel}
              onClick={() => setPopup(false)}
            />

            {popupView === "menu" && (
              <>
                <h1 className={classes.titleChequero}>¿Qué deseas ver?</h1>
                <div className={classes.subTitleChequero}>{card.codigo}</div>
                <div className={classes.subTitleChequero}>{card.titulo}</div>
                <div className={classes.menuContainer}>
                  <Button
                    className={classes.menuButton}
                    onClick={() => {
                      initPilotosForm();
                      setPopupView("pilotos");
                    }}
                  >
                    Ver Pilotos
                  </Button>
                  <Button
                    className={classes.menuButton}
                    onClick={() => setPopupView("montacargas")}
                  >
                    Ver Montacargas
                  </Button>
                </div>
              </>
            )}

            {popupView === "montacargas" && (
              <>
                <div className={classes.titleRow}>
                  {card?.extendedProps?.ingreso_salida === "Salida" && (
                    <div
                      className={classes.backCircle}
                      onClick={() => setPopupView("menu")}
                    >
                      <ArrowBackIcon style={{ fontSize: 20 }} />
                    </div>
                  )}
                  <h1
                    className={classes.titleChequero}
                    style={{ marginBottom: 0 }}
                  >
                    {tipo !== "salida" ? "Seleccione un chequero" : "Pilotos"}
                  </h1>
                </div>
                <p style={{ color: "#A6A8AA", fontFamily: "AlbertSansRegular" }}>
                  Asignar carta de aceptación a piloto de montacargas
                </p>
                {tipo !== "salida" && (
                  <>
                    <div className={classes.subTitleChequero}>{card.codigo}</div>
                    <div className={classes.subTitleChequero}>{card.titulo}</div>
                  </>
                )}

                <div className={classes.contChequeros}>
                  <div className={classes.contNombre}>Nombre</div>
                  {listUsers.map((checkBook, index) => (
                    <div
                      key={checkBook.usu_id}
                      onClick={() =>
                        handleChange(
                          {
                            target: {
                              checked: !checkedState[checkBook.usu_id],
                            },
                          },
                          checkBook.usu_id
                        )
                      }
                      className={`${classes.conChequero} ${
                        index === listUsers.length - 1
                          ? classes.lastConChequero
                          : ""
                      }`}
                    >
                      {checkBook.usu_nombres} {checkBook.usu_apellidos}
                      <Checkbox
                        style={{ color: "#69dfa5" }}
                        checked={!!checkedState[checkBook.usu_id]}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => handleChange(e, checkBook.usu_id)}
                      />
                    </div>
                  ))}
                </div>
                <div className={classes.container}>
                  <Button
                    className={classes.btnConfirm}
                    onClick={() => {
                      assignCheckBookHandler();
                    }}
                  >
                    Asignar
                  </Button>
                </div>
              </>
            )}

            {popupView === "pilotos" && (
              <>
                <div className={classes.titleRow}>
                  {card?.extendedProps?.ingreso_salida === "Salida" && (
                    <div
                      className={classes.backCircle}
                      onClick={() => setPopupView("menu")}
                    >
                      <ArrowBackIcon style={{ fontSize: 20 }} />
                    </div>
                  )}
                  <h1
                    className={classes.titleChequero}
                    style={{ marginBottom: 0 }}
                  >
                    Pilotos
                  </h1>
                </div>
                <div className={classes.subTitleChequero}>{card.codigo}</div>
                <div className={classes.subTitleChequero}>{card.titulo}</div>

                {pilotosForm.length === 0 ? (
                  <div className={classes.emptyState}>
                    No hay pilotos asignados
                  </div>
                ) : (
                  <div className={classes.pilotosList}>
                    {pilotosForm.map((piloto) => (
                      <div key={piloto.id_piloto} className={classes.pilotoCard}>
                        <div className={classes.pilotoField}>
                          <label className={classes.pilotoLabel}>Nombre</label>
                          <input
                            className={classes.pilotoInput}
                            value={piloto.nombre_piloto}
                            onChange={(e) =>
                              handlePilotoFieldChange(
                                piloto.id_piloto,
                                "nombre_piloto",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className={classes.pilotoField}>
                          <label className={classes.pilotoLabel}>
                            Documento
                          </label>
                          <input
                            className={classes.pilotoInput}
                            value={piloto.documento}
                            onChange={(e) =>
                              handlePilotoFieldChange(
                                piloto.id_piloto,
                                "documento",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className={classes.pilotoField}>
                          <label className={classes.pilotoLabel}>
                            Celular
                          </label>
                          <div className={classes.phoneInputWrapper}>
                            <CountrySelect
                              value={getPhoneCountry(piloto.area)}
                              countries={PHONE_COUNTRIES}
                              onChange={(iso) => {
                                try {
                                  handlePilotoFieldChange(
                                    piloto.id_piloto,
                                    "area",
                                    `+${getCountryCallingCode(iso)}`
                                  );
                                } catch {}
                              }}
                            />
                            <PhoneInput
                              country={getPhoneCountry(piloto.area)}
                              value={buildPhoneE164(piloto.area, piloto.celular)}
                              onChange={(e164) =>
                                handlePhoneChange(piloto.id_piloto, e164)
                              }
                              className={classes.pilotoInput}
                            />
                          </div>
                        </div>
                        <Button
                          className={classes.pilotoSaveBtn}
                          disabled={savingId === piloto.id_piloto}
                          onClick={() => handleSavePiloto(piloto)}
                        >
                          {savingId === piloto.id_piloto
                            ? "Guardando..."
                            : "Guardar"}
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      <Draggable
        // isDragDisabled={cardDisabled}
        draggableId={card.id}
        index={cardIndex}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.dragHandleProps}
            {...provided.draggableProps}
            onClick={openPopup}
          >

            <Paper
              className={`${classes.card} ${
                card.extendedProps.ingreso_salida === "Salida"
                  ? card.extendedProps?.ubicacion === "3B"
                    ? classes.dragItemStyleSalida3B
                    : classes.dragItemStyleSalida
                  : classes.dragItemStyleEntrada
              }`}
            >
              <h4>{valueElements}</h4>
              {content && <p className={classes.small}>{content}</p>}
            </Paper>
          </div>
        )}
      </Draggable>
    </div>
  );
};

export default Card;
